import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from 'entities/filters/base-url-params-filter';
import { CityPicker } from '../city-picker';
import { useSearchParams } from 'react-router-dom';

type CityParamFilterProps = BaseUrlParamsFilterProps & { countryQueryParamName?: string }

export const CityParamFilter = ({ 
  queryParamName,
  size = 'medium',
  countryQueryParamName = 'countryId'
}: CityParamFilterProps) => {

  const [searchParams] = useSearchParams();
  
  const countryIdParam = searchParams.get(countryQueryParamName);
  const countryId = countryIdParam ? Number(countryIdParam) : null;
  
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field
        fullWidth
        name={queryParamName}
        label={'Город'}
        clearable={true}
        size={size}
        component={CityPicker}
        countryId={countryId} />
    </BaseUrlParamsFilter>
  );
};
